export default class OperationalSystemEnum {
  public static ANDROID: string = 'android';
  public static IOS: string = 'ios';
}